import { Button, Dialog } from "@mui/material";
import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../../Meta.module.css";
import { useAuthUser } from "react-auth-kit";
import CounterButton from "../../../../../../../../components/CounterButton/CounterButton";
import CancelBtn from "../../../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../../../components/Buttons/SaveBtn";
import CountryCodePhoneInput from "../../../../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useSelector, useDispatch } from "react-redux";
import { createMetaAddonPaymentLink } from "../../../../../service/IntegrationsSlice";
import { getSubDomainAccessStatus } from "../../../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import PaymentLinkGenerated from "./PaymentLinkGenerated";
import { AppDispatch } from "../../../../../../../../redux/store";

function BuyAddons(props: any) {
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch: AppDispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );

  const { metaAddonPaymentLink } = useSelector(
    (state: any) => state.appIntegrations
  );

  const { invoiceSettings } = useSelector((state: any) => state.appSettings);
  const branches = useSelector((state: any) => state.branch.branchList);

  const filteredBranches = hasAllBranchAccess
    ? branches
    : branches?.filter((item: any) => item.id === userById?.branchId);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [stage, setStage] = useState<number>(1);
  const [contactNumber, setContactNumber] = React.useState<any>("");
  const [validStatePhone, setValidStatePhone] = React.useState<boolean>(true);
  const [showCountError, setShowCountError] = useState(false);
  const [countryCode, setCountryCode] = React.useState<any>("");
  const [bundleCounter, setBundleCounter] = React.useState<number>(0);
  const [branchArray, setBranchArray] = useState<any>([]);
  const [addOnpaymentLink, setAddOnPaymentLink] = useState({});
  const [showError, setShowError] = useState(false);
  const [showAmountError, setShowAmountError] = useState(false);
  const [taxlabel, setTaxlabel] = useState("GST(18%)");
  const [tax, setTax] = useState(0.18);
  const bundlePrice = 250;
  const bundleLeadCount = 500;
  const totalBranchCount = branchArray?.reduce(
    (acc: any, item: any) => acc + item.count,
    0
  );
  const totalLeads = bundleLeadCount * bundleCounter;
  const totalPrice = bundlePrice * bundleCounter;

  const bundleIncrement = () => {
    setShowCountError(false);
    setShowAmountError(false);
    setBundleCounter(bundleCounter + 1);
  };

  const bundleDecrement = () => {
    setShowCountError(false);
    setShowAmountError(false);
    setBundleCounter(Math.max(bundleCounter - 1, 1));
    const mappedBranchData = filteredBranches?.map((item: any) => {
      return {
        id: item?.id,
        branchName: item?.branchName,
        count: 0,
      };
    });
    setBranchArray(mappedBranchData);
    if (bundleCounter > 0) setBundleCounter(bundleCounter - 1);
    else {
      setBundleCounter(0);
      alert("min limit reached");
    }
  };

  const handleBranchIncrement = (index: number) => {
    setShowCountError(false);
    setShowAmountError(false);
    setBranchArray((prev: any) =>
      prev.map((item: any, i: number) =>
        i === index ? { ...item, count: item.count + 1 } : item
      )
    );
  };

  const handleBranchDecrement = (index: number) => {
    setShowCountError(false);
    setShowAmountError(false);
    setBranchArray((prev: any) =>
      prev.map((item: any, i: number) =>
        i === index ? { ...item, count: Math.max(item.count - 1, 0) } : item
      )
    );
  };
  const cancelButtonClick = () => {
    setStage(1);
    setIsOpen(false);
    setContactNumber("");
    setValidStatePhone(true);
    setCountryCode("");
    setBundleCounter(0);
    setShowAmountError(false);
    setShowCountError(false);
    setShowError(false);
    const mappedBranchData = filteredBranches?.map((item: any) => {
      return {
        id: item?.id,
        branchName: item?.branchName,
        count: 0,
      };
    });
    setBranchArray(mappedBranchData);
  };

  const handleSendPaymentLink = () => {
    const rawNumber = contactNumber.replace(countryCode, "");
    const valid = isValidPhoneNumber(rawNumber, "IN");
    const amount = totalPrice + totalPrice * tax;
    if (amount <= 0) {
      setShowAmountError(true);
    } else {
      setShowAmountError(false);
    }
    setShowError(!valid);
    const counterValid = bundleCounter == totalBranchCount;
    setShowCountError(!counterValid);
    if (valid && counterValid && !showAmountError) {
      // Submit form logic

      const data = {
        instituteId: userById?.instituteId,
        phoneNumber: contactNumber,
        phoneNumberCountryCode: countryCode,
        amount: totalPrice + totalPrice * tax,
        numberOfBundles: bundleCounter,

        branchData: branchArray.map((branch: any) => ({
          branchId: branch?.id,
          bundle: branch?.count,
        })),
        createdByName: `${authUser?.firstName} ${authUser?.lastName}`,
        createdById: authUser?.institute?.[0]?.id,
      };

      dispatch(createMetaAddonPaymentLink(data));
    }
  };

  const cancelPopupButtonClick = () => {
    cancelButtonClick();
  };

  React.useEffect(() => {
    const mappedBranchData = filteredBranches?.map((item: any) => {
      return {
        id: item?.id,
        branchName: item?.branchName,
        count: 0,
      };
    });
    setBranchArray(mappedBranchData);
  }, [branches]);

  useEffect(() => {
    if (invoiceSettings) {
      setTaxlabel("GST(18%)");
      setTax(0.18);
    }
  }, [invoiceSettings]);

  useEffect(() => {
    if (metaAddonPaymentLink) setAddOnPaymentLink(metaAddonPaymentLink);
    setStage(2);
  }, [metaAddonPaymentLink]);

  useEffect(() => {
    setStage(1);
  }, []);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        sx={{
          fontSize: 14,
          textTransform: "capitalize",
          boxShadow: "none",
          height: "38px",
        }}
        size={"small"}
        onClick={() => setIsOpen(!isOpen)}
      >
        <AddIcon sx={{ marginRight: "10px", fontSize: "18px" }} />
        Add Credits
      </Button>
      <Dialog
        open={isOpen}
        sx={{
          zIndex: "99999",
          minWidth: "490px",

          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "500px",
            maxHeight: "500px",
            minHeight: "200px",
            padding: "0px",
            borderRadius: "8px",
            boxShadow:
              "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
            background: "#FFFFFF",
            overflow: "hidden",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <div>
          {stage === 1 && (
            <>
              <div className={styles.addOnPopupHead}>
                <div className={styles.addOnPopupTitle}>Buy Addon Credits</div>
                <div className={styles.closeModalButton}>
                  <CloseIcon
                    sx={{ color: "#555555", cursor: "pointer" }}
                    onClick={cancelButtonClick}
                  />
                </div>
              </div>
              <div className={styles.addOnPopupChild}>
                <div className={styles.addOnPopupDesc}>
                  You can select number of additional leads you want.
                </div>
                <div className={`${styles.splitDev} ${styles.defaultPriceBox}`}>
                  <div>Price per additional 500 leads</div>
                  <div>250/-</div>
                </div>
                <div className={styles.bundelesBox}>
                  <div
                    className={`${styles.splitDev} ${styles.bundleCounterWrap}`}
                  >
                    <div className={styles.bundelesLabel}>
                      Number Of Bundles
                    </div>
                    <div>
                      <CounterButton
                        count={bundleCounter}
                        onIncrement={bundleIncrement}
                        onDecrement={bundleDecrement}
                      />
                    </div>
                  </div>
                  <div className={styles.branchesBundleWrap}>
                    {branchArray?.map((item: any, index: number) => (
                      <div
                        className={`${styles.splitDev} ${styles.branchesCounterWrap}`}
                        key={index}
                      >
                        <div className={styles.branchesBundeleLabel}>
                          {item?.branchName}
                        </div>
                        <div>
                          <CounterButton
                            count={item?.count}
                            onIncrement={() => handleBranchIncrement(index)}
                            onDecrement={() => handleBranchDecrement(index)}
                            incrementDisable={
                              totalBranchCount < bundleCounter
                                ? false
                                : true || bundleCounter === 0
                            }
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div>
                    {showCountError && (
                      <p
                        style={{
                          color: "#f44336",
                          fontSize: " 0.75rem",
                          fontWeight: "400",
                        }}
                      >
                        Sum of bundles in branch data does not match number of
                        bundles
                      </p>
                    )}
                  </div>
                  <div>
                    <div className={`${styles.splitDev} ${styles.summaryWrap}`}>
                      <div className={styles.paySummaryLabel}>
                        Total Additional Leads
                      </div>
                      <div
                        className={styles.paySummaryValue}
                        style={{ marginRight: "14PX" }}
                      >
                        {totalLeads}
                      </div>
                    </div>

                    <div className={`${styles.splitDev}`}>
                      <div className={styles.paySummaryLabel}>Net Price</div>
                      <div
                        className={styles.paySummaryValue}
                        style={{ marginRight: "14PX" }}
                      >
                        {totalLeads / 2}
                      </div>
                    </div>

                    <div className={`${styles.splitDev} `}>
                      <div className={styles.paySummaryLabel}>{taxlabel}</div>
                      <div
                        className={styles.paySummaryValue}
                        style={{ marginRight: "14PX" }}
                      >
                        {(totalPrice * 18) / 100}
                      </div>
                    </div>

                    <div className={styles.splitDev}>
                      <div className={styles.paySummaryLabel}>Final Price </div>
                      <div className={styles.paySummaryValue}>{`${
                        totalPrice + totalPrice * tax
                      }/-`}</div>
                    </div>
                  </div>
                </div>
                {showAmountError && (
                  <div
                    style={{
                      color: "#f44336",
                      fontSize: " 0.75rem",
                      fontWeight: "400",
                    }}
                  >
                    Amount should be a valid positive number
                  </div>
                )}
                <div className={`${styles.splitDev} ${styles.phoneFieldWrap}`}>
                  <div className={styles.phoneLabel}>Enter Phone Number</div>
                  <div className={styles.phoneField}>
                    <CountryCodePhoneInput
                      value={contactNumber}
                      disableDropdown={true}
                      onChange={(event: any, country: any) => {
                        setContactNumber(event);
                        setCountryCode(country.dialCode);
                        setShowError(false); //
                      }}
                      error={!showError}
                    />
                  </div>
                </div>
                <div className={styles.paymentNote}>
                  ( The payment link will be send to this number )
                </div>
              </div>
              <div className={styles.addOnBtnSplit}>
                <CancelBtn onClick={cancelButtonClick} />
                <SaveBtn
                  onClick={handleSendPaymentLink}
                  buttonText="Send Payment Link"
                />
              </div>
            </>
          )}
          {stage === 2 && addOnpaymentLink && (
            <PaymentLinkGenerated
              data={addOnpaymentLink}
              cancelButtonClick={cancelPopupButtonClick}
            />
          )}
        </div>
      </Dialog>
    </>
  );
}

export default BuyAddons;
